import React from 'react';
import { RouterProvider } from 'react-router-dom';

import router from 'ff/debrief/router';

import * as API from 'ff/debrief/features/TracklogApi';
import DebriefThemeProvider from 'ff/debrief/components/DebriefThemeProvider';
import ToastBar from 'ff/debrief/components/ToastBar';
import ProductDetailsPage from 'ff/debrief/components/ProductDetailsPage';

export const DebriefApp = () => {
    const tracklogsQuery = API.useGetAllTracklogsQuery({ page: 0 });
    const sharedTracklogsQuery = API.useGetAllSharedTracklogsQuery();
    const isEmptyList =
        tracklogsQuery.data?.totalTracklogs === 0 &&
        sharedTracklogsQuery.data?.length === 0;
    if (isEmptyList) {
        return (
            <DebriefThemeProvider>
                <ProductDetailsPage />
            </DebriefThemeProvider>
        );
    }
    return (
        <DebriefThemeProvider>
            <RouterProvider router={router} />
            <ToastBar />
        </DebriefThemeProvider>
    );
};

export default DebriefApp;
